import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import "./HowItWorks.css";

const HowItWorks = () => {
  return (
    <div className="hiw-page">
      {/* Hero */}
      <section className="hiw-hero">
        <div className="hiw-badge"><span className="hiw-badge-dot"></span> RAG Technology Explained</div>
        <h1 className="hiw-title">
          Turn Your Docs into<br />
          <span className="hiw-gradient">Actionable Intelligence</span>
        </h1>
        <p className="hiw-subtitle">
          Contextly AI bridges the gap between your static files and dynamic answers. See how our engine processes your data in three simple steps.
        </p>
      </section>

      {/* Steps */}
      <section className="hiw-steps">
        <div className="hiw-step-card">
          <span className="step-bg-num">01</span>
          <div className="step-icon blue"><i className="fa fa-cloud-upload-alt"></i></div>
          <h3>Upload Sources</h3>
          <p>Simply drag and drop your knowledge base. We support PDFs, DOCX, TXT, and direct integrations with Notion & Google Drive.</p>
          <div className="step-tags">
            <span>PDF Support</span><span>OCR Ready</span><span>Secure</span>
          </div>
        </div>
        <div className="hiw-step-card">
          <span className="step-bg-num">02</span>
          <div className="step-icon cyan"><i className="fa fa-map-pin"></i></div>
          <h3>AI Processing</h3>
          <p>Our engine reads, chunks, and vectorizes your data. It builds a semantic map of your information for instant, context-aware retrieval.</p>
          <div className="step-tags">
            <span>Vector Embeddings</span><span>Smart Chunking</span>
          </div>
        </div>
        <div className="hiw-step-card">
          <span className="step-bg-num">03</span>
          <div className="step-icon green"><i className="fa fa-comment-dots"></i></div>
          <h3>Interactive Chat</h3>
          <p>Ask questions in natural language. Contextly retrieves the exact paragraphs needed and generates a cited answer instantly.</p>
          <div className="step-tags">
            <span>Citations</span><span>History</span><span>Export</span>
          </div>
        </div>
      </section>

      {/* RAG Architecture */}
      <section className="hiw-rag">
        <div className="hiw-rag-inner">
          <div className="hiw-rag-left">
            <h2>Advanced RAG Architecture</h2>
            <div className="rag-features">
              <div className="rag-feature">
                <i className="fa fa-check-circle"></i>
                <div>
                  <strong>Semantic Search</strong>
                  <p>We don't just match keywords. We match meaning.</p>
                </div>
              </div>
              <div className="rag-feature">
                <i className="fa fa-check-circle"></i>
                <div>
                  <strong>Hallucination Guardrails</strong>
                  <p>Answers are strictly grounded in your provided documents.</p>
                </div>
              </div>
              <div className="rag-feature">
                <i className="fa fa-check-circle"></i>
                <div>
                  <strong>Enterprise Security</strong>
                  <p>SOC-2 compliant data handling and encryption.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="hiw-rag-right">
            <div className="rag-chat-preview">
              <div className="rag-chat-bar">
                <span className="demo-dot red"></span>
                <span className="demo-dot yellow"></span>
                <span className="demo-dot green"></span>
                <span className="rag-chat-title">Chat Preview</span>
              </div>
              <div className="rag-chat-body">
                <div className="rag-msg user">
                  What is the return policy mentioned in the handbook?
                </div>
                <div className="rag-msg bot">
                  <span className="rag-bot-icon">C</span>
                  <div>
                    According to page 12 of the Employee Handbook, returns must be processed within 30 days of purchase with a valid receipt.
                    <div className="rag-source">Source: Handbook_v2.pdf</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="hiw-cta">
        <h2>Ready to chat with your data?</h2>
        <p>Join thousands of professionals using Contextly AI to extract insights in seconds, not hours.</p>
        <div className="hiw-cta-buttons">
          <Link to="/" className="btn-primary">Try Contextly Free <i className="fa fa-arrow-right"></i></Link>
          <Link to="/" className="btn-secondary"><i className="fa fa-play-circle"></i> Watch Demo</Link>
        </div>
        <p className="hiw-cta-note">No credit card required · 14-day free trial · Cancel anytime</p>
      </section>

      <Footer />
    </div>
  );
};

export default HowItWorks;
